import React from 'react';
import Select from 'react-select';
import Switch from 'react-ios-switch';
import globalEnum from '../../../enums/globalEnum';
import { useResponsive } from '../../../hooks/useResponsive';
import tools from '../../../utils/tools';
import { IUser, IService, IDistrict } from '../../../types/types';

interface UserInfoSectionProps {
  user: IUser;
  setUser: React.Dispatch<React.SetStateAction<IUser>>;
  services: IService[];
  districts: IDistrict[];
  selectedWorkerServices: string[];
  setSelectedWorkerServices: React.Dispatch<React.SetStateAction<string[]>>;
  selectedDistricts: string[];
  setSelectedDistricts: React.Dispatch<React.SetStateAction<string[]>>;
  activeSection: string;
}

const UserInfoSection: React.FC<UserInfoSectionProps> = ({
                                                           user,
                                                           setUser,
                                                           services,
                                                           districts,
                                                           selectedWorkerServices,
                                                           setSelectedWorkerServices,
                                                           selectedDistricts,
                                                           setSelectedDistricts,
  activeSection
                                                         }) => {
  const { isMobile, getSelectStyles } = useResponsive();
  return (
    <section className={`userInfo ${isMobile && activeSection !== 'info' ? 'hidden-mobile' : ''}`}>
      <h1 className="dashBoardTitle">اطلاعات کاربر</h1>
      <div className={`userInfoContainer user ${isMobile ? 'mobile-container' : ''}`}>
        <div className={`section30 ${isMobile ? 'mobile-section' : ''}`}>
          {user?.role === globalEnum.roles.WORKER && (
            <>
              <label className="sideBarTitle">خدمت مربوطه</label>
              <Select
                styles={getSelectStyles()}
                options={tools.selectFormatter(services, 'id', 'title', 'انتخاب کنید')}
                defaultValue={selectedWorkerServices?.map(e => ({
                  value: e,
                  label: services.find(j => j.id == Number(e))?.title
                }))}
                className="width100"
                isMulti={true}
                name='workerServices'
                onChange={(selected: any) => setSelectedWorkerServices(selected.map((e: any) => e.value))}
                placeholder="انتخاب خدمات"
              />

              <label className="sideBarTitle">درصد همکاری</label>
              <input
                className="editProductInput"
                defaultValue={user?.percent}
                name="percent"
                type="number"
                min="0"
                max="100"
                placeholder="درصد همکاری"
              />

              <label className="sideBarTitle">مناطق تحت پوشش</label>
              <Select
                styles={getSelectStyles()}
                options={tools.selectFormatter(districts, 'id', 'title', 'انتخاب کنید')}
                defaultValue={selectedDistricts?.map(e => ({
                  value: e,
                  label: districts.find(j => j.id === e)?.title
                }))}
                className="width100"
                isMulti={true}
                name='districts'
                onChange={(selected: any) => setSelectedDistricts(selected.map((e: any) => e.value))}
                placeholder="انتخاب مناطق"
              />
            </>
          )}

          {(user?.role === globalEnum.roles.SUPER_ADMIN || user?.role === globalEnum.roles.OPERATOR || user?.role === globalEnum.roles.WORKER) && (
            <>
              <label className="sideBarTitle">نام کاربری</label>
              <input
                className="editProductInput"
                defaultValue={user?.username}
                name="username"
                placeholder="نام کاربری"
              />

              <label className="sideBarTitle">
                رمز عبور
                <small>(فقط در صورت نیاز به تغییر وارد کنید)</small>
              </label>
              <input
                className="editProductInput"
                name="password"
                type="password"
                placeholder="رمز عبور جدید"
              />
            </>
          )}

          {user?.role === globalEnum.roles.USER && (
            <>
              <label className="sideBarTitle">قابلیت انتخاب آرایشگر</label>
              <div className="switch-container">
                <Switch
                  checked={user?.isWorkerChoosable || false}
                  name="isWorkerChoosable"
                  onChange={(checked) => setUser(prev => ({ ...prev, isWorkerChoosable: checked }))}
                />
                <span className="switch-label">
                  {user?.isWorkerChoosable ? 'فعال' : 'غیرفعال'}
                </span>
              </div>
            </>
          )}
        </div>

        <div className={`section30 ${isMobile ? 'mobile-section' : ''}`}>
          <label className="sideBarTitle">نام</label>
          <input
            className="editProductInput"
            defaultValue={user?.name}
            name="name"
            placeholder="نام"
            required
          />

          <label className="sideBarTitle">نام خانوادگی</label>
          <input
            className="editProductInput"
            defaultValue={user?.lastName}
            name="lastName"
            placeholder="نام خانوادگی"
            required
          />

          <label className="sideBarTitle">شماره تلفن</label>
          <input
            className="editProductInput"
            defaultValue={user?.phoneNumber}
            name="phoneNumber"
            type="tel"
            placeholder="09123456789"
            maxLength={11}
            required
          />
        </div>

        <div className={`section30 ${isMobile ? 'mobile-section' : ''}`}>
          <label className="sideBarTitle">وضعیت</label>
          <select
            className={`selector30 ${isMobile ? 'mobile-select' : ''}`}
            value={user?.status || 0}
            name="status"
            onChange={(e) => setUser(prev => ({ ...prev, status: Number(e.target.value) }))}
          >
            <option value={0}>غیر فعال</option>
            <option value={1}>فعال</option>
          </select>

          <label className="sideBarTitle">نقش کاربری</label>
          <select
            className={`selector30 ${isMobile ? 'mobile-select' : ''}`}
            name="role"
            value={user?.role || ''}
            onChange={(e) => setUser(prev => ({ ...prev, role: e.target.value }))}
          >
            {Object.entries(globalEnum.roles).map(([key, value]) => (
              <option value={key} key={key}>{value}</option>
            ))}
          </select>

          <label className="sideBarTitle">کد ملی</label>
          <input
            className="editProductInput"
            defaultValue={user?.nationalCode}
            name="nationalCode"
            placeholder="کد ملی 10 رقمی"
            maxLength={10}
            pattern="[0-9]{10}"
          />

          <label className="sideBarTitle">کیف پول</label>
          <input
            className="editProductInput"
            defaultValue={user?.walletBalance}
            name="walletBalance"
            type="number"
            min="0"
            placeholder="موجودی کیف پول"
          />
        </div>
      </div>
    </section>
  );
};

export default UserInfoSection;
